// extracted by mini-css-extract-plugin
module.exports = {"left_side":"_gC","right_side":"_gD","bottom_slider":"_gE","form_fullscreen":"_gF","footer":"_gG"};